import CircleGraphComponent from "./circle-graph-component";
export default CircleGraphComponent;
